import { Turbo } from "@hotwired/turbo-rails";
import scrollSpy from "@sidsbrmnn/scrollspy";

window.Turbo = Turbo;

import "./main.scss";

import { createApp } from "vue";
import Home from "@/components/views/Home.vue";
import "animate.css";

if (document.querySelector("#home")) {
  const home = createApp(Home);
  home.mount("#home");
}

const options = {
  sectionSelector: "section", // Query selector to your sections
  targetSelector: ".nav-link", // Query selector to your elements that will be added `active` class
  activeClass: "activeNav",
  offset: 100, // Menu item will active before scroll to a matched section 100px
};

// Initialize
window.onload = function () {
  console.log("loaded");
  scrollSpy(document.getElementById("navMain"), options);
};

function checkVisible(element) {
  var rect = element.getBoundingClientRect();
  var viewHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight,
  );
  const visible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  if (visible) {
    window.removeEventListener("scroll", () => checkVisible(element), {
      passive: true,
    });
    element.classList.add("animate__animated", "animate__fadeInDown");
  }
  return;
}

document.addEventListener("turbo:load", () => {
  console.log("called");

  const elementsToAnimate = document.querySelectorAll(".animateWhenVisible");
  console.log(elementsToAnimate);
  if (elementsToAnimate.length > 0) {
    elementsToAnimate.forEach((element) => {
      window.addEventListener("scroll", () => checkVisible(element), {
        passive: true,
      });
    });
  }
});
